import * as tslib_1 from "tslib";
import { checkIsMobile } from '@techmore/global';
import { isPlatformBrowser } from '@angular/common';
import { ElementRef, NgZone, AfterViewInit, Renderer2, OnDestroy } from '@angular/core';
import { GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { parseQueryPqrams } from 'src/app/util';
export class ShareSocialModalComponent {
    constructor(generatorEnv, platformId, router, route, el, zone, renderer, gALoggerService, templateService, globalComponentService) {
        this.generatorEnv = generatorEnv;
        this.platformId = platformId;
        this.router = router;
        this.route = route;
        this.el = el;
        this.zone = zone;
        this.renderer = renderer;
        this.gALoggerService = gALoggerService;
        this.templateService = templateService;
        this.globalComponentService = globalComponentService;
        /** 彈出視窗是否開啟中 */
        this.isOpened = false;
        this.isBrowser = isPlatformBrowser(this.platformId);
        if (this.isBrowser) {
            window['onClassroomShare'] = () => {
                this.logtoGA('google_classroom');
            };
        }
        this._setFBIdSubc = this.templateService.siteInfo$.subscribe(siteInfo => {
            this.fbAppId = siteInfo.metadata.facebookClientId;
        });
    }
    ngAfterViewInit() {
        if (this.isBrowser) {
            if (location.href.indexOf('/subject/') !== -1) {
                // 主題頁
                this.pageUrl = location.href;
            }
            else if (location.href.indexOf('/detail') !== -1) {
                // 素材頁
                const qp = parseQueryPqrams(location.search);
                this.pageUrl = `${location.origin}${location.pathname}?indexCode=${qp['indexCode']}&id=${qp['id']}`;
            }
            else {
                // 根本不知道有人拿這個組件放到單筆多筆去，只能這邊幫人家補上
                this.pageUrl = location.href;
            }
        }
    }
    ngOnDestroy() {
        if (this.modal && this.modal.isOpened) {
            this.modal.close();
        }
        if (this._setFBIdSubc) {
            this._setFBIdSubc.unsubscribe();
            delete this._setFBIdSubc;
        }
    }
    logtoGA(socialType) {
        if (this.isBrowser) {
            if (this.pageUrl.indexOf('/subject/') !== -1) {
                // 主題頁
                const themeId = location.pathname.split('/')[3];
                this.gALoggerService.log({
                    event: 'share_theme',
                    'share_social': socialType,
                    'page_id': themeId,
                });
            }
            else if (location.href.indexOf('/detail') !== -1) {
                // 素材頁
                this.gALoggerService.log({
                    event: 'share_material',
                    'share_social': socialType,
                    'page_id': this.route.snapshot.queryParams['id'],
                    'fetch_index': this.route.snapshot.queryParams['indexCode'],
                });
            }
        }
    }
    share2FB() {
        const isMobile = checkIsMobile();
        if (isMobile) {
            if (location.href.startsWith('https://') && this.fbAppId) {
                window.open(`https://www.facebook.com/dialog/share?app_id=${this.fbAppId}&display=popup&href=${encodeURIComponent(this.pageUrl)}&redirect_uri=${encodeURIComponent(this.pageUrl)}`, '_blank');
            }
            else {
                window.open('https://www.facebook.com/sharer.php?u=' + encodeURIComponent(this.pageUrl), '_blank');
            }
        }
        else {
            // 桌面版分享
            window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.pageUrl), '_blank', 'height=500,resizable=yes,scrollbars=yes,width=700');
        }
    }
    /** 開啟視窗 */
    open() {
        this.modal.open();
    }
    /** 關閉視窗 */
    close() {
        this.modal.close();
    }
    /** 複製 input 元素內容到剪貼簿 - 支援 iOS */
    copyToClipBoard(target) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const inputEl = target;
            if (!inputEl || inputEl.tagName !== 'INPUT') {
                console.error('copyToClipBoard，目標不是 input 元素');
                return false;
            }
            try {
                const text = inputEl.value;
                // 優先使用現代 Clipboard API
                if (navigator.clipboard && window.isSecureContext) {
                    // 確保 input 可以被選取
                    inputEl.readOnly = false;
                    inputEl.disabled = false;
                    // 聚焦並選取所有內容
                    inputEl.focus();
                    inputEl.select();
                    yield navigator.clipboard.writeText(text);
                    // 恢復原始狀態
                    inputEl.readOnly = true;
                    inputEl.blur(); // 移除焦點
                    return true;
                }
                // Fallback 到選取 + execCommand 方式
                return this.selectAndCopy(inputEl);
            }
            catch (error) {
                console.error('Clipboard API 複製失敗，嘗試 fallback 方式', error);
                // 如果 Clipboard API 失敗，嘗試 fallback 方式
                return this.selectAndCopy(inputEl);
            }
        });
    }
    /** 選取 input 內容並複製 */
    selectAndCopy(inputEl) {
        try {
            // 確保 input 可以被選取
            inputEl.readOnly = false;
            inputEl.disabled = false;
            // 聚焦並選取所有內容
            inputEl.focus();
            inputEl.select();
            // iOS 需要額外設置選取範圍
            if (this.isIOSDevice()) {
                inputEl.setSelectionRange(0, inputEl.value.length);
            }
            // 執行複製命令
            const successful = document.execCommand('copy');
            // 恢復原始狀態
            inputEl.readOnly = true;
            inputEl.blur(); // 移除焦點
            return successful;
        }
        catch (error) {
            console.error('selectAndCopy 選取複製失敗:', error);
            return false;
        }
    }
    /** 檢測是否為 iOS 設備 */
    isIOSDevice() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    }
    /** 顯示複製結果的輔助方法 */
    handleCopyWithFeedback(target) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const success = yield this.copyToClipBoard(target);
            if (!success) {
                console.log('複製失敗，請手動選取複製');
            }
            else if (this.isIOSDevice()) {
                window.alert('已複製到剪貼簿');
            }
        });
    }
}
